import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Overlay } from '@thd-olt-component-react/overlay';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import './VideoPlayer.scss';

const VideoPlayerComponent = ({ children, channel, videoId, className, videoStill, height, width, withOverlay }) => {
  const [overlay, setOverlay] = useState(false);

  const onVideoClick = (event) => {
    event.preventDefault();
    if (videoId) {
      setOverlay(true);
    }
  };

  /**
   * The optional withOverlay prop allows the VideoPlayer to open and
   * play on an overlay only when the channel is "desktop". Otherwise, the
   * VideoPlayer will just continue to play inline.
   */
  if (videoStill && withOverlay) {
    const ConditionalWrapper = ({ condition, wrapper, children }) =>
      condition ? wrapper(children) : children;

    return (
      <>
        <ConditionalWrapper
          condition={channel !== "mobile"}
          wrapper={(children) => (
            <a href="#" className={className} onClick={onVideoClick}>
              {children}
            </a>
          )}
        >
          <VideoPlayer
            videoId={videoId}
            videoStill={videoStill}
            className={`${className} video-player--full-width`}
            height={height}
            width={width}
            channel={channel}
          />
        </ConditionalWrapper>
        {overlay && channel !== "mobile" ? (
          <Overlay
            onClose={() => setOverlay(false)}
            open
            fit
            closeButton
            modalClass="etch-widgets__video-overlay__modal"
          >
            <div className="etch-widgets__video-overlay" data-testid="image-video-overlay">
              <VideoPlayer
                videoId={videoId}
                channel={channel}
                borderColor="black"
                autoPlay
                className="etch-widgets__video-overlay__player--overlay-active"
              />
            </div>
          </Overlay>
        ) : null}
      </>
    );
  }

  return (
    videoStill
    ? <VideoPlayer
        videoId={videoId}
        videoStill={videoStill}
        className={`${className} video-player--full-width`}
        height={height}
        width={width}
      />
    : <>
    <a href="#" className={className} onClick={onVideoClick}>
      {children}
    </a>
    {overlay && (
      <Suspense fallback={<div />}>
        <Overlay onClose={() => setOverlay(false)} open fit closeButton modalClass="etch-widgets__video-overlay__modal">
          <div className="etch-widgets__video-overlay" data-testid="image-video-overlay">
            <VideoPlayer videoId={videoId} channel={channel} borderColor="black" autoPlay className="etch-widgets__video-overlay__player" />
          </div>
        </Overlay>
      </Suspense>
    )}
  </>)
};

VideoPlayerComponent.propTypes = {
  channel: PropTypes.oneOf([
    'desktop',
    'mobile'
  ]),
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  videoStill: PropTypes.string,
  withOverlay: PropTypes.bool
};

VideoPlayerComponent.defaultProps = {
  channel: 'desktop',
  className: '',
  height: null,
  width: null,
  videoStill: null,
  withOverlay: false
};

export default VideoPlayerComponent;
